export default __webpack_public_path__ + "static/media/thum_6.ecb990da.png";